import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioGroup, MatRadioButton } from "@angular/material/radio";
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
@Component({
  selector: 'app-delete-event-dialog',
  imports: [MatCheckboxModule, MatRadioGroup, MatRadioButton, FormsModule, ReactiveFormsModule],
  templateUrl: './delete-event-dialog.component.html',
  styleUrl: './delete-event-dialog.component.sass'
})
export class DeleteEventDialogComponent implements OnInit {
productForm: FormGroup;
description: string = "";
removeSelected: boolean = false;
mode="";
allowDelete = false;
constructor(private fb:FormBuilder,
    public dialogRef: MatDialogRef<DeleteEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, previewUrl: string, isVideo: boolean, previewFileType: string, description: string, isDeleteArchiveMode: boolean, idToRemove: string}
  ) {}

  ngOnInit(): void {
    this.productForm = this.fb.group({
      removetype: new FormControl("", Validators.required),
    });
  }

  closeEventDialog(){
    const retVal = {confirm: false, mode: this.mode};
    this.dialogRef.close(retVal);
  }
 
  onRemoveSelected(event: any){
    this.mode = event.value;
    this.allowDelete = true;
    this.removeSelected = true;
    if(this.mode == "delete"){
      //wait for checkbox to be checked
      this.allowDelete = false;
    }
  }

 onCheckboxChange(checked: boolean) {
      console.log('Checkbox state changed:', checked);
      this.allowDelete = checked;
      // Perform actions based on the new state
  }
  
  onRemove(confirm: boolean){
    const retVal = {confirm: confirm, mode: this.mode};
    this.dialogRef.close(retVal);
  }
}
